import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGetEligibleCandidatesApiResponse, IGetEligibleCandidatesPayload } from '../types';

export const getEligibleCandidates = async (
  payload: IGetEligibleCandidatesPayload,
): Promise<IGetEligibleCandidatesApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetEligibleCandidatesApiResponse>(
    `/offices/postings/${payload.postingId}/eligible-candidates`,
    { headers },
  );

  return response.data;
};
